/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, not unless you turn on sorting. By default the tool keeps every unique line in the same order it first appeared in your original list, only removing the later repeats. Enable 'Sort alphabetically' if you want the unique lines reordered A to Z instead of preserving their original position.`)
};

const es_rd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, a menos que actives ordenamiento. De forma predeterminada la herramienta mantiene cada línea única en el mismo orden en que apareció por primera vez en tu lista original, solo eliminando las repeticiones posteriores. Activa 'Ordenar alfabéticamente' si quieres que las líneas únicas se reordenen de la A a la Z en lugar de preservar su posición original.`)
};

const de_rd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein, es sei denn, Sie aktivieren die Sortierung. Standardmäßig behält das Tool jede eindeutige Zeile in der Reihenfolge bei, in der sie zuerst in Ihrer ursprünglichen Liste erschien, und entfernt nur die späteren Wiederholungen. Aktivieren Sie 'Alphabetisch sortieren', wenn Sie die eindeutigen Zeilen stattdessen von A bis Z neu geordnet haben möchten, anstatt ihre ursprüngliche Position beizubehalten.`)
};

const nl_rd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee, niet tenzij u sortering inschakelt. Standaard behoudt het hulpmiddel elke unieke regel in dezelfde volgorde als waarin deze voor het eerst in uw originele lijst verscheen, waarbij alleen de latere herhalingen worden verwijderd. Schakel "Alfabetisch sorteren" in als u de unieke regels van A tot Z opnieuw wilt ordenen in plaats van hun oorspronkelijke positie te behouden.`)
};

const fr_rd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non, sauf si vous activez le tri. Par défaut, l'outil conserve chaque ligne unique dans le même ordre qu'elle est apparue pour la première fois dans votre liste d'origine, en supprimant uniquement les répétitions ultérieures. Activez "Trier alphabétiquement" si vous souhaitez que les lignes uniques soient réorganisées de A à Z au lieu de préserver leur position d'origine.`)
};

const it_rd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, non a meno che tu non attivi l'ordinamento. Per impostazione predefinita, lo strumento mantiene ogni riga univoca nello stesso ordine in cui è apparsa per la prima volta nell'elenco originale, rimuovendo solo le ripetizioni successive. Abilita "Ordina alfabeticamente" se vuoi che le righe univoche siano riordinate da A a Z invece di preservare la loro posizione originale.`)
};

const pt_br2_rd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não, a menos que você ative a classificação. Por padrão, a ferramenta mantém cada linha única na mesma ordem em que apareceu pela primeira vez em sua lista original, removendo apenas as repetições posteriores. Ative 'Classificar alfabeticamente' se quiser que as linhas únicas sejam reorganizadas de A a Z em vez de preservar sua posição original.`)
};

const pt_rd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não, a menos que ative a ordenação. Por padrão, a ferramenta mantém cada linha única na mesma ordem em que apareceu pela primeira vez na sua lista original, removendo apenas as repetições posteriores. Ative 'Ordenar alfabeticamente' se quiser que as linhas únicas sejam reordenadas de A a Z em vez de preservar a sua posição original.`)
};

const ja_rd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。ソートをオンにしない限りです。デフォルトでは、ツールはすべての一意の行を元のリストで最初に表示される順序と同じ順序に保持し、以降の繰り返しのみを削除します。代わりに一意の行をA〜Z順に並べ替える場合は、「アルファベット順にソート」を有効にしてください。`)
};

const zh_rd_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会，除非你开启排序功能。默认情况下，工具会按照每一行在原始列表中首次出现的顺序保留所有唯一行，只移除之后的重复项。如果你希望唯一行按 A 到 Z 重新排序，而不是保持原有位置，可开启“按字母顺序排序”。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_faq4_a", locale)
	if (locale === "en") return en_rd_faq4_a(inputs)
	if (locale === "es") return es_rd_faq4_a(inputs)
	if (locale === "de") return de_rd_faq4_a(inputs)
	if (locale === "nl") return nl_rd_faq4_a(inputs)
	if (locale === "fr") return fr_rd_faq4_a(inputs)
	if (locale === "it") return it_rd_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_rd_faq4_a(inputs)
	if (locale === "pt") return pt_rd_faq4_a(inputs)
	if (locale === "ja") return ja_rd_faq4_a(inputs)
	return zh_rd_faq4_a(inputs)
};